module.exports = ".th-error {\n  width: 30%; }\n"